//All buttons and fields
export const genRegonBtn = document.querySelector('#regonBtn');
export const regonValue = document.querySelector('#regonValue');

export const genPeselBtn = document.querySelector('#peselBtn');
export const peselValue = document.querySelector('#pselValue');

export const genNipBtn = document.querySelector('#nipBtn');
export const nipValue = document.querySelector('#nipValue');

export const genIdNumberBtn = document.querySelector('#idNumberBtn');
export const idNumberValue = document.querySelector('#idNumberValue');

export const genIbanBtn = document.querySelector('#ibanBtn');
export const ibanValue = document.querySelector('#ibanValue');

export const copySuccess = document.getElementById('copy-scs');
